import { default as account_45deleteMBvpazBOXlMeta } from "/vercel/path0/pages/account-delete.vue?macro=true";
import { default as careers4lXeegTIcrMeta } from "/vercel/path0/pages/careers.vue?macro=true";
import { default as contactJnsDpYVejzMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as privacykJ3SQnmrN4Meta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as return_45policyuPUCJTHfYzMeta } from "/vercel/path0/pages/return-policy.vue?macro=true";
import { default as termsq5qlZHSSonMeta } from "/vercel/path0/pages/terms.vue?macro=true";
export default [
  {
    name: "account-delete___ar",
    path: "/ar/account-delete",
    component: () => import("/vercel/path0/pages/account-delete.vue").then(m => m.default || m)
  },
  {
    name: "account-delete___en",
    path: "/account-delete",
    component: () => import("/vercel/path0/pages/account-delete.vue").then(m => m.default || m)
  },
  {
    name: "careers___ar",
    path: "/ar/careers",
    component: () => import("/vercel/path0/pages/careers.vue").then(m => m.default || m)
  },
  {
    name: "careers___en",
    path: "/careers",
    component: () => import("/vercel/path0/pages/careers.vue").then(m => m.default || m)
  },
  {
    name: "contact___ar",
    path: "/ar/contact",
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy___ar",
    path: "/ar/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "return-policy___ar",
    path: "/ar/return-policy",
    component: () => import("/vercel/path0/pages/return-policy.vue").then(m => m.default || m)
  },
  {
    name: "return-policy___en",
    path: "/return-policy",
    component: () => import("/vercel/path0/pages/return-policy.vue").then(m => m.default || m)
  },
  {
    name: "terms___ar",
    path: "/ar/terms",
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: "terms___en",
    path: "/terms",
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  }
]